<script lang="ts">
	import type { ProductConfig } from '$lib/brand/types';

	interface Props {
		product?: ProductConfig;
		className?: string;
	}

	let { product, className = '' }: Props = $props();

	// Format price only if product exists
	const formattedPrice = $derived(product ? new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: product.currency
	}).format(product.price) : '');
</script>

{#if product}
<div class="product-cta {className}">
	<div class="cta-content">
		<div class="cta-text">
			<h3>{product.name}</h3>
			<p class="price">{formattedPrice}</p>
			<p class="description">{product.description}</p>
		</div>

		<div class="cta-action">
			<a href="{product.checkoutUrl}" class="buy-button" target="_blank" rel="noopener noreferrer">
				Buy Now
			</a>
		</div>
	</div>
</div>

<style>
	.product-cta {
		background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-secondary) 100%);
		color: white;
		padding: 2rem;
		border-radius: 12px;
		margin: 2rem 0;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	}

	.product-cta .cta-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 2rem;
	}

	.product-cta .cta-text h3 {
		font-size: 1.5rem;
		margin: 0 0 0.5rem 0;
		font-weight: 600;
	}

	.product-cta .cta-text .price {
		font-size: 1.25rem;
		font-weight: bold;
		margin: 0 0 0.75rem 0;
		opacity: 0.9;
	}

	.product-cta .cta-text .description {
		font-size: 1rem !important;
		margin: 0 !important;
		opacity: 0.9;
		line-height: 1.5;
	}

	.product-cta .cta-action {
		flex-shrink: 0;
	}

	.product-cta .buy-button {
		display: inline-block;
		background: white;
		color: var(--brand-primary);
		padding: 0.875rem 1.75rem;
		font-size: 1.1rem;
		font-weight: 600;
		text-decoration: none;
		border-radius: 8px;
		transition: all 0.3s ease;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.product-cta .buy-button:hover {
		background: #f8fafc;
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
	}

	@media (max-width: 768px) {
		.product-cta {
			padding: 1.5rem;
		}

		.product-cta .cta-content {
			flex-direction: column;
			text-align: center;
			gap: 1.5rem;
		}

		.product-cta .cta-text h3 {
			font-size: 1.25rem;
		}

		.product-cta .cta-text .price {
			font-size: 1.1rem;
		}

		.product-cta .cta-text .description {
			font-size: 0.95rem;
		}

		.product-cta .buy-button {
			font-size: 1rem;
			padding: 0.75rem 1.5rem;
		}
	}
</style>
{/if}
